import { Link } from "react-router-dom";
import { Users, CalendarDays } from "lucide-react";
import { Avatar, AvatarStack, Progress, StatusBadge } from "./bits";
import { fileUrl, fmtDate, label, money } from "../lib/api";

export const GroupCard = ({ g }) => {
  const pct = g.goal_amount ? Math.min(100, (g.total_contributions / g.goal_amount) * 100) : null;
  return (
    <Link to={`/app/groups/${g.id}`} data-testid={`group-card-${g.id}`} className="card card-hover overflow-hidden flex flex-col">
      <div className="h-32 bg-nini-mint relative">
        {g.image_url && <img src={fileUrl(g.image_url)} alt="" className="absolute inset-0 w-full h-full object-cover" />}
        <span className="absolute top-3 right-3"><StatusBadge status={g.status} /></span>
        {g.logo_url && <span className="absolute -bottom-5 left-5 h-12 w-12 rounded-full ring-4 ring-white bg-white overflow-hidden shadow-soft" data-testid={`group-logo-${g.id}`}><img src={fileUrl(g.logo_url)} alt="" className="w-full h-full object-cover" /></span>}
      </div>
      <div className="p-5 flex flex-col gap-3 flex-1">
        <div className="flex items-start justify-between gap-3">
          <div className="min-w-0">
            <div className="font-semibold text-nini-heading truncate">{g.name}</div>
            <div className="text-xs text-nini-muted">{label(g.category)}</div>
          </div>
          <span className="text-[11px] font-semibold px-2 py-0.5 rounded-full bg-nini-surface text-nini-muted">{label(g.my_role || "member")}</span>
        </div>
        <div>
          <div className="flex items-baseline gap-1.5">
            <span className="font-bold text-nini-heading">{money(g.total_contributions, g.currency)}</span>
            {g.goal_amount && <span className="text-xs text-nini-muted">/ {money(g.goal_amount, g.currency)}</span>}
          </div>
          <Progress value={pct ?? 100} className="mt-2" tone={pct === null ? "sage" : "green"} />
        </div>
        <div className="flex items-center justify-between mt-auto pt-1">
          <AvatarStack people={g.member_avatars} max={4} extra={Math.max(0, g.member_count - 4)} />
          <div className="flex items-center gap-3 text-xs text-nini-muted">
            <span className="inline-flex items-center gap-1"><Users size={13} />{g.member_count}</span>
            {g.next_contribution_date && <span className="inline-flex items-center gap-1"><CalendarDays size={13} />{fmtDate(g.next_contribution_date)}</span>}
          </div>
        </div>
      </div>
    </Link>
  );
};

export const GroupMini = ({ g }) => (
  <Link to={`/app/groups/${g.id}`} className="flex items-center gap-3 p-3 rounded-xl hover:bg-nini-surface transition">
    <Avatar src={g.image_url} name={g.name} size="h-10 w-10 rounded-xl" className="!rounded-xl" />
    <div className="min-w-0 flex-1">
      <div className="text-sm font-semibold text-nini-heading truncate">{g.name}</div>
      <div className="text-xs text-nini-muted">{g.member_count} members · {label(g.my_role)}</div>
    </div>
    <span className="text-sm font-semibold text-nini-heading">{money(g.recorded_balance, g.currency)}</span>
  </Link>
);
